import styled from 'styled-components';

export const Base = styled.a`
  color: var(--t-link-text-color);
  font-family: var(--t-base-font-family);
  box-sizing: border-box;
  &:focus-visible {
    outline: 2px solid var(--t-brand-alt-color);
    outline-offset: 2px;
  }
  background-color: transparent;
  padding: 0;

  position: relative;
  /* DUX-1153 Global Styles overrides: body a */
  font-weight: 500;

  /* DUX-1153 Global Styles overrides: .m-link */
  &.m-link {
    display: inline-flex;
    align-items: center;
    border-bottom-width: 1px;
    line-height: 1.5;

    &:hover,
    &:focus {
      border-bottom-width: 1px;
      font-weight: 500;
    }
  }

  /* Text size variations */
  &.md {
    font-size: 1rem;
  }
  &.sm {
    font-size: 0.875rem;
  }
  &.xs {
    font-size: 0.75rem;
  }

  /* Spacing for external link icon */
  &.ext {
    margin-inline-end: 1.25rem;
  }

  .icon-container {
    position: absolute;
    left: 100%; // change to right: 100% for RTL directionality
  }
`;
